import { useTranslation } from '@unifyapps/i18n/client';
import AlertTriangle from '@unifyapps/icons/outline/AlertTriangle';
import { EmptyStateDeprecated as BaseEmptyStateDeprecated } from '@unifyapps/ui/components/EmptyStateDeprecated';
import { FeaturedIcon } from '@unifyapps/ui/components/FeaturedIcon';
import { useMemo } from 'react';

export function ErrorState() {
  const { t } = useTranslation(['notifications']);

  const icon = useMemo(() => <FeaturedIcon color="error" Icon={AlertTriangle} size="lg" />, []);

  return <BaseEmptyStateDeprecated icon={icon} title={t('common:ErrorState.SomethingWentWrong')} />;
}
